<template>
<div class="goDieUnlucky" :style="{backgroundImage:`url(${goDieUnlucky.background.pictureUrl})`}">
  <div class="title" :style="{backgroundImage:`url(${goDieUnlucky.title.pictureUrl})`}"></div>
  <div class="rulesBtn" :style="{backgroundImage:`url(${goDieUnlucky.rulesBtn.pictureUrl})`}"></div>
  <div class="myPrize" :style="{backgroundImage:`url(${goDieUnlucky.myPrize.pictureUrl})`}"></div>
  <div class="start" :style="{backgroundImage:`url(${goDieUnlucky.start.pictureUrl})`}"></div>
</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('market', ['marketingActivityData', 'cover'])
  },
  data () {
    return {
      goDieUnlucky: {}
    }
  },
  created () {
    this.goDieUnlucky = JSON.parse(this.marketingActivityData.activity.templePage).drawPage.goDieUnlucky
  }
}
</script>

<style lang="scss" scoped>
.goDieUnlucky{
  height: 682px;
  background-size: 100% 100%;
  position: relative;
  *{
    background-size: 100% auto;
    background-repeat: no-repeat;
    position: absolute;
  }
  .title{
    width: 300px;
    height: 200px;
    position: absolute;
    left: 0;
    right: 0;
    top: 44px;
    margin: auto;
  }
  .rulesBtn,.myPrize{
    width: 100px;
    height: 30px;
    position: absolute;
    right: 0;
  }

  .rulesBtn{
    top: 100px;
  }
  .myPrize{
    top: 140px;
  }
  .start{
    width: 200px;
    height: 60px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 34px;
  }
}
</style>
